var base = require('auth/register-stripe');

Vue.component('spark-register-stripe', {
    props: [],

    data() {
        return {
            registerForm: {
                invite_code: Register.invite_code
            },
            step: 'plan',
            planVersions: {
                'snazzydocs-hustle-monthly': '',
                'snazzydocs-hustle-yearly': '',
                'snazzydocs-essentials-monthly': '-1499-v1',
                'snazzydocs-essentials-yearly': '-16499-v1',
                'snazzydocs-pro-monthly': '-3999-v1',
                'snazzydocs-pro-yearly': '-43999-v1',
                'snazzydocs-ent-monthly': '-24999-v1',
                'snazzydocs-ent-yearly': '-274999-v1',
            }
        };
    },


    // mixins: [base],

    mixins: [
        base,
        require('./../mixins/plans')
    ],

    // computed: {
    //     // hiddenPlans() {
    //     //     return [
    //     //         'snazzydocs-beta-monthly',
    //     //         'snazzydocs-ent-monthly-24999-v1',
    //     //         'snazzydocs-ent-yearly-274999-v1'
    //     //     ]
    //     // },


    // },

    created() {

        if (location.hash) {

            if (location.hash === '#billing') {
                this.step = '#account';
                window.location.hash = 'account';
            } else {
                this.step = location.hash;
            }

        } else {
            this.step = '#plan';
        }

        if (this.query.email) this.registerForm.email = this.query.email


    },

    methods: {

        /**
         * Select the given plan.
         */
        selectPlan(plan) {
            // console.log('new selectPlan');
            // console.log('plan: ', plan);
            // console.log('location.hash: ', location.hash);

            let paramPlanName = 'snazzydocs-hustle-monthly'
            if (plan.id.includes('essentials')) paramPlanName = `snazzydocs-essentials-${plan.interval}`
            if (plan.id.includes('pro')) paramPlanName = `snazzydocs-pro-${plan.interval}`
            // if (plan.id.includes('ent')) paramPlanName = `snazzydocs-ent-${plan.interval}`

            if (history.pushState) {
                var newurl = `${window.location.origin}${window.location.pathname}?plan=${paramPlanName}${location.hash}`;
                window.history.pushState({
                    path: newurl
                }, '', newurl);
            }

            this.selectedPlan = plan;

            this.registerForm.plan = plan.id;

            // if (plan.id.includes('hustle')) {

            // }
        },

        changeStep(new_step) {

            this.step = new_step;
            location.hash = new_step;

        },

        validateStep(step) {

            this.registerForm.errors.forget();

            if (step === '#register') {
                // Terms
                this.registerForm.terms = true

                // if (!this.registerForm.terms) {
                //     console.log('no terms');
                //     this.registerForm.errors.set({
                //         terms: ['The terms must be accepted.']
                //     })
                // }

                if (!this.registerForm.errors.hasErrors()) {
                    this.register();
                }
            }

            if (step === '#account') {

                // Name
                if (this.registerForm.name === '') { }

                // Email
                if (this.registerForm.email === '') {
                    this.registerForm.errors.set({
                        email: ['Email address is required.']
                    })
                }

                // Password
                if (this.registerForm.email !== '' && this.registerForm.password === '') {
                    this.registerForm.errors.set({
                        password: ['Please set a password.']
                    })
                }

                // Password Confirmation
                if (this.registerForm.password !== '' && this.registerForm.password_confirmation === '') {
                    this.registerForm.errors.set({
                        password_confirmation: ['Please confirm password.']
                    })
                }

                // Password & Password Confirmation not the same
                if (this.registerForm.password_confirmation !== '' && this.registerForm.password !== this.registerForm.password_confirmation) {
                    this.registerForm.errors.set({
                        password_confirmation: ['Passwords are not the same.']
                    })
                }

                if (!this.registerForm.errors.hasErrors()) {
                    this.changeStep('#billing');
                }

            }

        },


        /**
         * Select the appropriate default plan for registration.
         * Overwriting laravel\spark\resoures\assets\js\mixins\register.js to set default plan to URL hash if present.
         */
        selectAppropriateDefaultPlan() {

            if (this.query.plan) {

                this.selectPlanById(`${this.query.plan}${this.planVersions[this.query.plan]}`) || this.selectPlanByName(`${this.query.plan}${this.planVersions[this.query.plan]}`);

                if (this.query.plan.includes('yearly')) {
                    Vue.set(this, 'showingYearlyPlans', true)
                    Vue.set(this, 'showingMonthlyPlans', false)
                }

            } else if (this.query.invitation) {
                this.selectFreePlan();
            } else if (this.paidPlansForActiveInterval.length > 0) {
                this.selectPlan(this.paidPlansForActiveInterval[0]);
            } else {
                this.selectFreePlan();
            }

        },



    }
});